import { FieldSelectionList } from 'lib-knowledge-form';
import { usePaginatedCollections } from 'lib-knowledge-management-common/hooks/usePaginatedCollections';
import { Control, UseFormSetValue } from 'react-hook-form';

import { ArticleAddModalSchema } from './articleAddModalSchema';

type CollectionSelectProps = {
  initialId: string | undefined;
  control: Control<ArticleAddModalSchema>;
  setValue: UseFormSetValue<ArticleAddModalSchema>;
};

export const CollectionSelect = ({
  initialId,
  control,
  setValue,
}: CollectionSelectProps): JSX.Element => {
  // Every page, since the list cannot ask for more as it scrolls
  const { data, loading } = usePaginatedCollections({
    fetchAll: true,
    fetchPolicy: 'cache-and-network',
    onCompleted: (_data) => {
      // Make sure the initial value has the "name"
      if (!initialId) return;
      const collection = _data.collections.results.find(
        (c) => c.id === initialId,
      );

      if (collection) {
        setValue('collectionId', [
          {
            id: collection.id,
            name: collection.title,
          },
        ]);
      }
    },
  });

  const items =
    data?.collections.results
      .filter((c) => !c.isSyncedWithElevio)
      .map((c) => ({ id: c.id, name: c.title })) ?? [];

  return (
    <FieldSelectionList
      label="Collection"
      required
      control={control}
      name="collectionId"
      placeholders={{
        loading: 'Loading collections...',
        empty: 'Select a collection',
      }}
      itemsLoading={loading}
      listItems={items}
      equalityFn={(a, b) => a.id === b.id}
      multiple={false}
    />
  );
};
